import { useState } from 'react';

interface ILockingSubmission {
  submissionId: number | null;
  title: string | null;
}

export interface ILockable {
  isLockedByOtherSubmission: boolean;
  lockingSubmissionId: number | null;
  lockingSubmissionTitle: string | null;
}

export const useLockedItemInterception = () => {
  const [lockingSubmission, setLockingSubmission] = useState<ILockingSubmission | null>(null);

  const closeLockedModal = () => setLockingSubmission(null);

  const openLockedModal = (item: ILockable) =>
    setLockingSubmission({ submissionId: item.lockingSubmissionId, title: item.lockingSubmissionTitle });

  // Returns true (and opens the dialog) when the item belongs to another submission, so callers
  // can short-circuit the original action.
  const blockIfLocked = (item?: ILockable | null): boolean => {
    if (item?.isLockedByOtherSubmission) {
      openLockedModal(item);
      return true;
    }

    return false;
  };

  const withLockGuard =
    <TArgs extends [string, ...unknown[]]>(
      findLockedItem: (id: string) => ILockable | undefined,
      action: (...args: TArgs) => void,
    ) =>
    (...args: TArgs) => {
      if (blockIfLocked(findLockedItem(args[0]))) {
        return;
      }

      action(...args);
    };

  return {
    isLockedModalOpen: lockingSubmission !== null,
    lockingSubmission,
    closeLockedModal,
    blockIfLocked,
    withLockGuard,
  };
};
